import LanguageDetector from "i18next-browser-languagedetector";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import resources from "locales";

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: "en_GB",
    debug: process.env.NODE_ENV === "development",
    keySeparator: ":" // prevent deep objects
  });

export default i18n;
